'use strict'

export const MEDIA = {
  tv: '(min-width: 2780px)',

  screenL: '(max-width: 1920px)',
  'screenL<': '(min-width: 1920px)',
  screenM: '(max-width: 1680px)',
  'screenM<': '(min-width: 1680px)',
  screenS: '(max-width: 1440px)',
  'screenS<': '(min-width: 1440px)',
  tabletL: '(max-width: 1366px)',
  'tabletL<': '(min-width: 1366px)',
  tabletM: '(max-width: 1280px)',
  'tabletM<': '(min-width: 1280px)',
  tabletS: '(max-width: 1024px)',
  'tabletS<': '(min-width: 1024px)',
  mobileL: '(max-width: 768px)',
  'mobileL<': '(min-width: 768px)',
  mobileM: '(max-width: 560px)',
  'mobileM<': '(min-width: 560px)',
  mobileS: '(max-width: 480px)',
  'mobileS<': '(min-width: 480px)',
  mobileXS: '(max-width: 375px)',
  'mobileXS<': '(min-width: 375px)',

  light: '(prefers-color-scheme: light)',
  dark: '(prefers-color-scheme: dark)',

  print: 'print'
}
